import React, { useEffect, useState } from 'react'
import { Check as CheckIcon } from 'react-feather'
import { size } from 'lodash'
import { Box, Button, Grid, Typography } from '@material-ui/core'

import {
  Consents,
  Container,
  ContentHeader,
  LoadingFeedback,
  Page,
  SectionCard,
} from 'components'

import { ExpirationEditForm } from './components'

import useFetch from 'hooks/useFetch'
import useConsent from 'hooks/useConsent'

import constants from 'constants/index'
import * as service from 'service'
import theme from 'theme'

const ConsentEdit = ({ match }) => {
  const { consentFormId } = match?.params
  const { FORM_EDIT_STEPS } = constants.consent

  const [loading, setLoading] = useState(true)

  const {
    activeStep,
    backStep,
    lastActiveStep,
    setToNextStep,
    setDataConsentForm,
  } = useConsent()

  const { response, isLoading, refresh } = useFetch(
    service.dponet.consent.get,
    { consentFormId },
    [consentFormId],
    !!consentFormId,
  )

  const consentForm = response?.data?.consentForm

  const loadingRequests = isLoading || loading

  const isLastStep = activeStep === size(FORM_EDIT_STEPS) - 1

  const handleNextStep = () => setToNextStep(true)

  useEffect(() => {
    setLoading(true)
    if (!!consentForm && !isLoading) {
      const defaultValues = {
        ...consentForm,
        ...(consentForm?.components && {
          components: JSON.parse(consentForm?.components),
        }),
      }

      setDataConsentForm({ ...defaultValues })
      setLoading(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [!!consentForm, isLoading])

  return (
    <Page title="Editar Formulário de Consentimento">
      <Container maxWidth={false}>
        <LoadingFeedback open={isLoading || loading} />
        <ContentHeader title="Editar Formulário" />
        {consentForm?.expirationConfig?.expiration && (
          <SectionCard
            title={<Typography variant="h5">Data de Expiração</Typography>}
            mb={2}
          >
            <ExpirationEditForm consentForm={consentForm} />
          </SectionCard>
        )}
        <SectionCard
          title={
            <Typography variant="h5">Campos e pre-visualização</Typography>
          }
        >
          <Grid container spacing={3}>
            <Grid item xs={12} md={9}>
              {activeStep === 0 && !loadingRequests && <Consents.Fields />}
              {activeStep === 1 && !loadingRequests && (
                <Consents.Preview
                  isEditConsent
                  isAccepted
                  refresh={refresh}
                  setLoading={setLoading}
                />
              )}
            </Grid>
            <Grid item xs={12} md={3}>
              <Consents.Stepper
                steps={FORM_EDIT_STEPS}
                lastActiveStep={lastActiveStep}
              />
              <Box
                display="flex"
                justifyContent="space-between"
                gridGap={theme.spacing(2)}
                py={2}
              >
                <Button
                  variant="outlined"
                  onClick={backStep}
                  disabled={activeStep === 0}
                >
                  VOLTAR
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  startIcon={<CheckIcon />}
                  onClick={handleNextStep}
                >
                  {isLastStep ? 'Salvar' : 'Próximo'}
                </Button>
              </Box>
            </Grid>
          </Grid>
        </SectionCard>
      </Container>
    </Page>
  )
}

export default ConsentEdit
